// categoryColors.js

// Original colors
const baseColors = [
  "#e6194b",
  "#3cb44b",
  "#ffe119",
  "#0072b2",
  "#f58231",
  "#911eb4",
  "#46f0f0",
  "#f032e6",
  "#a9a9a9",
  "#d55e00",
  "#008080",
  "#800080",
  "#aa6e28",
  "#ff1493",
  "#800000",
  "#006400",
  "#808000",
  "#ff8c00",
  "#000080",
  "#4b0082",
];

// Shuffle array on module load
const distinctColors = [...baseColors].sort(() => Math.random() - 0.5);

// Map to store category → color
const categoryColorMap = {};

/**
 * Returns a color for the given category.
 * If category already has a color assigned, returns the same color.
 * Otherwise, assigns the first unused color from the shuffled array.
 * Loops around if more categories than colors.
 */
export const getCategoryColor = (category) => {
  if (!categoryColorMap[category]) {
    const usedColors = new Set(Object.values(categoryColorMap));
    let color = distinctColors.find((c) => !usedColors.has(c));

    // If all colors are used, loop from the beginning
    if (!color) {
      color =
        distinctColors[
          Object.keys(categoryColorMap).length % distinctColors.length
        ];
    }

    categoryColorMap[category] = color;
  }
  return categoryColorMap[category];
};

// Optional: export full map for debugging
export const CATEGORY_COLOR_MAP = categoryColorMap;
